import { GamePreview } from "./components/GamePreview";

export default GamePreview;
